import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { fetchCardType, fetchOtherNationality } from "../EPCApplications/CardType";

export const getFormsSubmissionsDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  enquiries: [
    {
      fieldName: "Name",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name",
      placeholder: "Enter Name",
      validation: { required: "Name is required" },
    },
    {
      fieldName: "Enquiry Type",
      fieldValue: "category",
      className: "col-span-6",
      type: "text",
      name: "category",
      formType: "input",
      label: "Enquiry Type",
      placeholder: "Enter Enquiry Type",
      validation: { required: "Enquiry Type is required" },
    },
    {
      fieldName: "Email",
      fieldValue: "email",
      className: "col-span-6",
      type: "text",
      name: "email",
      formType: "input",
      label: "Email",
      placeholder: "Enter Email",
      // validation: { required: "Email is required" },
    },
    {
      fieldName: "Mobile Number",
      fieldValue: "mobile",
      className: "col-span-6",
      type: "text",
      name: "mobile",
      formType: "input",
      label: "Mobile Number",
      placeholder: "Enter Mobile Number",
      // validation: { required: "Mobile Number is required" },
    },
    {
      fieldName: "Message",
      fieldValue: "message",
      className: "col-span-6",
      type: "text",
      name: "message",
      formType: "input",
      label: "Message",
      placeholder: "Enter Message",
      // validation: { required: "Message is required" },
    },
    {
      fieldName: "Reply Message",
      fieldValue: "replyMessage",
      className: "col-span-6",
      type: "text",
      name: "replyMessage",
      formType: "richText",
      label: "Reply Message",
      placeholder: "Enter Reply Message",
      // validation: { required: "Message is required" },
    },
    {
      fieldName: "Reply At",
      fieldValue: "repliedAt",
      className: "col-span-6",
      type: "dateTime",
      name: "repliedAt",
      formType: "dateTime",
      label: "Reply At",
      placeholder: "Enter Reply At",
      // validation: { required: "Message is required" },
    },
  ],
  epcApplications:[
    {
      fieldName: "EPC ID",
      fieldValue: "epcId",
      className: "col-span-6",
      type: "text",
      name: "epcId",
      formType: "input",
      label: "EPC ID",
      placeholder: "Enter EPC ID",
      // validation: { required: "EPC ID is required" },
      editable: false
    },
    {
      fieldName: "Membership Status",
      fieldValue: "epcStatus",
      className: "col-span-6",
      type: "text",
      name: "epcStatus",
      formType: "select",
      label: "Membership Status",
      placeholder: "Enter Membership Status",
      validation: { required: "Membership Status is required",
        validate: (value) => {
          console.log("validateeeee", value);
          if (
            ["Pending Approval (New Upgrade)", "Pending Approval (New Renewal)", "Pending Approval (New EPC)"].includes(value)
          ) {
            return "Membership Status is required";
          }
          return true;
        },
       },
      options:  [
        // {
        //     label: 'All',
        //     value: 'All'
        // },
        {
            label: 'ACTIVE',
            value: 'ACTIVE'
        },
        // {
        //   label: 'Pending Approval (New EPC)',
        //   value: 'Pending Approval (New EPC)'
        // },
        // {
        //   label: 'Pending Approval (New Upgrade)',
        //   value: 'Pending Approval (New Upgrade)'
        // },
        // {
        //   label: 'Pending Approval (New Renewal)',
        //   value: 'Pending Approval (New Renewal)'
        // },
        {
          label: 'EXPIRED',
          value: 'EXPIRED'
        },
        {
          label: 'SUSPENDED',
          value: 'SUSPENDED'
        },
      ]
    }, 
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "dropdownWithInput",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
      options: [{
        label: "Mr",
        value: "Mr"
      },{
        label: "Mrs",
        value: "Mrs"
      },{
        label: "Ms",
        value: "Ms"
      },{
        label: "Mdm",
        value: "Mdm"
      },{
        label: "Datuk",
        value: "Datuk"
      },{
        label: "Dato",
        value: "Dato"
      },{
        label: "Datuk Seri",
        value: "Datuk Seri"
      },{
        label: "Other",
        value: "Other"
      }]
    },
    {
      fieldName: "Name",
      fieldValue: "firstName",
      className: "col-span-6",
      type: "text",
      name: "firstName",
      formType: "input",
      label: "Name",
      placeholder: "Enter Name",
      validation: { required: "Name is required" },
    },
    // {
    //   fieldName: "NRIC",
    //   fieldValue: "nric",
    //   className: "col-span-6",
    //   type: "number",
    //   name: "nric",
    //   formType: "input",
    //   label: "NRIC",
    //   placeholder: "Enter NRIC",
    //   validation: { required: "NRIC is required" },
    // },
    {
      fieldName: "Card Type",
      fieldValue: "epcType",
      className: "col-span-6",
      type: "text",
      name: "epcType",
      formType: "select",
      label: "Card Type",
      placeholder: "Enter Card Type",
      validation: { required: "Card Type is required" },
      // options: [{
      //   label: "Classic",
      //   value: "Classic"
      // },
      // {
      //   label: "Preferred",
      //   value: "Preferred"
      // },
      // {
      //   label: "Priority",
      //   value: "Priority"
      // }]
      loadOptions: fetchCardType
    },
    {
      fieldName: "Profession",
      fieldValue: "profession",
      className: "col-span-6",
      type: "text",
      name: "profession",
      formType: "dropdownWithInput",
      label: "Profession",
      placeholder: "Enter Profession",
      showField: (formValues: any) => formValues.epcType === "PRIORITY",
      validation: {
        validate: (value: string, formValues: any) => {
          if (formValues.epcType === "PRIORITY" && !value) {
            return "Profession is required";
          }
          return true; 
        },
      },
      options: [
        { label: "CHAIRMAN MAHB", value: "CHAIRMAN MAHB" },
        { label: "CHAIRMAN MAN", value: "CHAIRMAN MAN" },
        { label: "MANAGING DIRECTOR", value: "MANAGING DIRECTOR" },
        { label: "BOD MAHB", value: "BOD MAHB" },
        { label: "BOD MAN", value: "BOD MAN" },
        { label: "CFO", value: "CFO" },
        { label: "COO", value: "COO" },
        { label: "SGM", value: "SGM" },
        { label: "GM", value: "GM" }
      ]
    },
    {
      fieldName: "Passport Number",
      fieldValue: "passportNumber",
      className: "col-span-6",
      type: "text",
      name: "passportNumber",
      formType: "input",
      label: "Passport Number",
      placeholder: "Enter Passport Number",
      // validation: { required: "Passport Number is required" },
      validation: {
        validate: (value, formValues) => {
          const epcType = formValues.epcType;
          if (epcType !== "PRIORITY" && !value) {
            return "Passport Number is required";
          }
          return true;
        },
      },
    },  
    {
      fieldName: "Date of Birth",
      fieldValue: "dateOfBirth",
      className: "col-span-6",
      type: "date",
      name: "dateOfBirth",
      formType: "date",
      label: "Date of Birth",
      placeholder: "Enter Date of Birth",
      validation: { required: "Date of Birth is required" },
      futureDateRestriction: true
    },
    {
      fieldName: "Country",
      fieldValue: "country",
      className: "col-span-6",
      type: "text",
      name: "country",
      formType: "select",
      label: "Country",
      placeholder: "Enter Country",
      // validation: { required: "Country is required" },
      validation: {
        validate: (value, formValues) => {
          const epcType = formValues.epcType;
          if (epcType !== "PRIORITY" && !value) {
            return "Country is required";
          }
          return true;
        },
      },
      options:
      [
       { label: 'Select Country', value: '' },
       { label: 'Afghanistan', value: 'Afghanistan' },
       { label: 'Albania', value: 'Albania' },
       { label: 'Algeria', value: 'Algeria' },
       { label: 'Andorra', value: 'Andorra' },
       { label: 'Angola', value: 'Angola' },
       { label: 'Antigua and Barbuda', value: 'Antigua and Barbuda' },
       { label: 'Argentina', value: 'Argentina' },
       { label: 'Armenia', value: 'Armenia' },
       { label: 'Australia', value: 'Australia' },
       { label: 'Austria', value: 'Austria' },
       { label: 'Azerbaijan', value: 'Azerbaijan' },
       { label: 'Bahamas', value: 'Bahamas' },
       { label: 'Bahrain', value: 'Bahrain' },
       { label: 'Bangladesh', value: 'Bangladesh' },
       { label: 'Barbados', value: 'Barbados' },
       { label: 'Belarus', value: 'Belarus' },
       { label: 'Belgium', value: 'Belgium' },
       { label: 'Belize', value: 'Belize' },
       { label: 'Benin', value: 'Benin' },
       { label: 'Bhutan', value: 'Bhutan' },
       { label: 'Bolivia', value: 'Bolivia' },
       { label: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina' },
       { label: 'Botswana', value: 'Botswana' },
       { label: 'Brazil', value: 'Brazil' },
       { label: 'Brunei', value: 'Brunei' },
       { label: 'Bulgaria', value: 'Bulgaria' },
       { label: 'Burkina Faso', value: 'Burkina Faso' },
       { label: 'Burundi', value: 'Burundi' },
       { label: 'Cabo Verde', value: 'Cabo Verde' },
       { label: 'Cambodia', value: 'Cambodia' },
       { label: 'Cameroon', value: 'Cameroon' },
       { label: 'Canada', value: 'Canada' },
       { label: 'Central African Republic', value: 'Central African Republic' },
       { label: 'Chad', value: 'Chad' },
       { label: 'Chile', value: 'Chile' },
       { label: 'China', value: 'China' },
       { label: 'Colombia', value: 'Colombia' },
       { label: 'Comoros', value: 'Comoros' },
       { label: 'Congo, Democratic Republic of the', value: 'Congo, Democratic Republic of the' },
       { label: 'Congo, Republic of the', value: 'Congo, Republic of the' },
       { label: 'Costa Rica', value: 'Costa Rica' },
       { label: 'Croatia', value: 'Croatia' },
       { label: 'Cuba', value: 'Cuba' },
       { label: 'Cyprus', value: 'Cyprus' },
       { label: 'Czech Republic', value: 'Czech Republic' },
       { label: 'Denmark', value: 'Denmark' },
       { label: 'Djibouti', value: 'Djibouti' },
       { label: 'Dominica', value: 'Dominica' },
       { label: 'Dominican Republic', value: 'Dominican Republic' },
       { label: 'Ecuador', value: 'Ecuador' },
       { label: 'Egypt', value: 'Egypt' },
       { label: 'El Salvador', value: 'El Salvador' },
       { label: 'Equatorial Guinea', value: 'Equatorial Guinea' },
       { label: 'Eritrea', value: 'Eritrea' },
       { label: 'Estonia', value: 'Estonia' },
       { label: 'Eswatini', value: 'Eswatini' },
       { label: 'Ethiopia', value: 'Ethiopia' },
       { label: 'Fiji', value: 'Fiji' },
       { label: 'Finland', value: 'Finland' },
       { label: 'France', value: 'France' },
       { label: 'Gabon', value: 'Gabon' },
       { label: 'Gambia', value: 'Gambia' },
       { label: 'Georgia', value: 'Georgia' },
       { label: 'Germany', value: 'Germany' },
       { label: 'Ghana', value: 'Ghana' },
       { label: 'Greece', value: 'Greece' },
       { label: 'Grenada', value: 'Grenada' },
       { label: 'Guatemala', value: 'Guatemala' },
       { label: 'Guinea', value: 'Guinea' },
       { label: 'Guinea-Bissau', value: 'Guinea-Bissau' },
       { label: 'Guyana', value: 'Guyana' },
       { label: 'Haiti', value: 'Haiti' },
       { label: 'Honduras', value: 'Honduras' },
       { label: 'Hungary', value: 'Hungary' },
       { label: 'Iceland', value: 'Iceland' },
       { label: 'India', value: 'India' },
       { label: 'Indonesia', value: 'Indonesia' },
       { label: 'Iran', value: 'Iran' },
       { label: 'Iraq', value: 'Iraq' },
       { label: 'Ireland', value: 'Ireland' },
       // { label: 'Israel', value: 'Israel' },
       { label: 'Italy', value: 'Italy' },
       { label: 'Jamaica', value: 'Jamaica' },
       { label: 'Japan', value: 'Japan' },
       { label: 'Jordan', value: 'Jordan' },
       { label: 'Kazakhstan', value: 'Kazakhstan' },
       { label: 'Kenya', value: 'Kenya' },
       { label: 'Kiribati', value: 'Kiribati' },
       { label: 'Kuwait', value: 'Kuwait' },
       { label: 'Kyrgyzstan', value: 'Kyrgyzstan' },
       { label: 'Laos', value: 'Laos' },
       { label: 'Latvia', value: 'Latvia' },
       { label: 'Lebanon', value: 'Lebanon' },
       { label: 'Lesotho', value: 'Lesotho' },
       { label: 'Liberia', value: 'Liberia' },
       { label: 'Libya', value: 'Libya' },
       { label: 'Liechtenstein', value: 'Liechtenstein' },
       { label: 'Lithuania', value: 'Lithuania' },
       { label: 'Luxembourg', value: 'Luxembourg' },
       { label: 'Malaysia', value: 'Malaysia' },
       { label: 'Madagascar', value: 'Madagascar' },
       { label: 'Malawi', value: 'Malawi' },
       { label: 'Maldives', value: 'Maldives' },
       { label: 'Mali', value: 'Mali' },
       { label: 'Malta', value: 'Malta' },
       { label: 'Marshall Islands', value: 'Marshall Islands' },
       { label: 'Mauritania', value: 'Mauritania' },
       { label: 'Mauritius', value: 'Mauritius' },
       { label: 'Mexico', value: 'Mexico' },
       { label: 'Micronesia', value: 'Micronesia' },
       { label: 'Moldova', value: 'Moldova' },
       { label: 'Monaco', value: 'Monaco' },
       { label: 'Mongolia', value: 'Mongolia' },
       { label: 'Montenegro', value: 'Montenegro' },
       { label: 'Morocco', value: 'Morocco' },
       { label: 'Mozambique', value: 'Mozambique' },
       { label: 'Myanmar', value: 'Myanmar' },
       { label: 'Namibia', value: 'Namibia' },
       { label: 'Nauru', value: 'Nauru' },
       { label: 'Nepal', value: 'Nepal' },
       { label: 'Netherlands', value: 'Netherlands' },
       { label: 'New Zealand', value: 'New Zealand' },
       { label: 'Nicaragua', value: 'Nicaragua' },
       { label: 'Niger', value: 'Niger' },
       { label: 'Nigeria', value: 'Nigeria' },
       { label: 'North Macedonia', value: 'North Macedonia' },
       { label: 'Norway', value: 'Norway' },
       { label: 'Oman', value: 'Oman' },
       { label: 'Pakistan', value: 'Pakistan' },
       { label: 'Palau', value: 'Palau' },
       { label: 'Panama', value: 'Panama' },
       { label: 'Papua New Guinea', value: 'Papua New Guinea' },
       { label: 'Paraguay', value: 'Paraguay' },
       { label: 'Peru', value: 'Peru' },
       { label: 'Philippines', value: 'Philippines' },
       { label: 'Poland', value: 'Poland' },
       { label: 'Portugal', value: 'Portugal' },
       { label: 'Qatar', value: 'Qatar' },
       { label: 'Romania', value: 'Romania' },
       { label: 'Russia', value: 'Russia' },
       { label: 'Rwanda', value: 'Rwanda' },
       { label: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis' },
       { label: 'Saint Lucia', value: 'Saint Lucia' },
       { label: 'Saint Vincent and the Grenadines', value: 'Saint Vincent and the Grenadines' },
       { label: 'Samoa', value: 'Samoa' },
       { label: 'San Marino', value: 'San Marino' },
       { label: 'Sao Tome and Principe', value: 'Sao Tome and Principe' },
       { label: 'Saudi Arabia', value: 'Saudi Arabia' },
       { label: 'Senegal', value: 'Senegal' },
       { label: 'Serbia', value: 'Serbia' },
       { label: 'Seychelles', value: 'Seychelles' },
       { label: 'Sierra Leone', value: 'Sierra Leone' },
       { label: 'Singapore', value: 'Singapore' },
       { label: 'Slovakia', value: 'Slovakia' },
       { label: 'Slovenia', value: 'Slovenia' },
       { label: 'Solomon Islands', value: 'Solomon Islands' },
       { label: 'Somalia', value: 'Somalia' },
       { label: 'South Africa', value: 'South Africa' },
       { label: 'South Korea', value: 'South Korea' },
       { label: 'South Sudan', value: 'South Sudan' },
       { label: 'Spain', value: 'Spain' },
       { label: 'Sri Lanka', value: 'Sri Lanka' },
       { label: 'Sudan', value: 'Sudan' },
       { label: 'Suriname', value: 'Suriname' },
       { label: 'Sweden', value: 'Sweden' },
       { label: 'Switzerland', value: 'Switzerland' },
       { label: 'Syria', value: 'Syria' },
       { label: 'Taiwan', value: 'Taiwan' },
       { label: 'Tajikistan', value: 'Tajikistan' },
       { label: 'Tanzania', value: 'Tanzania' },
       { label: 'Thailand', value: 'Thailand' },
       { label: 'Timor-Leste', value: 'Timor-Leste' },
       { label: 'Togo', value: 'Togo' },
       { label: 'Tonga', value: 'Tonga' },
       { label: 'Trinidad and Tobago', value: 'Trinidad and Tobago' },
       { label: 'Tunisia', value: 'Tunisia' },
       { label: 'Turkey', value: 'Turkey' },
       { label: 'Turkmenistan', value: 'Turkmenistan' },
       { label: 'Tuvalu', value: 'Tuvalu' },
       { label: 'Uganda', value: 'Uganda' },
       { label: 'Ukraine', value: 'Ukraine' },
       { label: 'United Arab Emirates', value: 'United Arab Emirates' },
       { label: 'United Kingdom', value: 'United Kingdom' },
       { label: 'United States', value: 'United States' },
       { label: 'Uruguay', value: 'Uruguay' },
       { label: 'Uzbekistan', value: 'Uzbekistan' },
       { label: 'Vanuatu', value: 'Vanuatu' },
       { label: 'Vatican City', value: 'Vatican City' },
       { label: 'Venezuela', value: 'Venezuela' },
       { label: 'Vietnam', value: 'Vietnam' },
       { label: 'Yemen', value: 'Yemen' },
       { label: 'Zambia', value: 'Zambia' },
       { label: 'Zimbabwe', value: 'Zimbabwe' },
     ]
    },
    {
      fieldName: "State",
      fieldValue: "state",
      className: "col-span-6",
      type: "text",
      name: "state",
      formType: "dropdownWithInput",
      label: "State",
      placeholder: "Enter State",
      // validation: { required: "State is required" },
      validation: {
        validate: (value, formValues) => {
          const epcType = formValues.epcType;
          if (epcType !== "PRIORITY" && !value) {
            return "State is required";
          }
          return true;
        },
      },
      options : [
        { label: "Johor", value: "Johor" },
        { label: "Kedah", value: "Kedah" },
        { label: "Kelantan", value: "Kelantan" },
        { label: "Malacca", value: "Malacca" },
        { label: "Negeri Sembilan", value: "Negeri Sembilan" },
        { label: "Pahang", value: "Pahang" },
        { label: "Penang", value: "Penang" },
        { label: "Perak", value: "Perak" },
        { label: "Perlis", value: "Perlis" },
        { label: "Sabah", value: "Sabah" },
        { label: "Sarawak", value: "Sarawak" },
        { label: "Selangor", value: "Selangor" },
        { label: "Terengganu", value: "Terengganu" },
        { label: "Kuala Lumpur", value: "Kuala Lumpur" },
        { label: "Labuan", value: "Labuan" },
        { label: "Putrajaya", value: "Putrajaya" },
      ]
    },
    {
      fieldName: "Expiry Date",
      fieldValue: "epcExpiry",
      className: "col-span-6",
      type: "date",
      name: "epcExpiry",
      formType: "dateWithCheckbox",
      label: "Expiry Date",
      placeholder: "Enter Expiry Date",
      validation: { required: "Expiry Date is required" },
      editable:false
    },
    {
      fieldName: "Gender",
      fieldValue: "gender",
      className: "col-span-6",
      type: "text",
      name: "gender",
      formType: "select",
      label: "Gender",
      placeholder: "Enter Gender",
      validation: { required: "Gender is required" },
      options: [{
        label: "Male",
        value: "Male"
      },{
        label: "Female",
        value: "Female"
      }]
    },
    {
      fieldName: "Mobile Number Country Code",
      fieldValue: "mobileNumberCountryCode",
      className: "col-span-6",
      type: "mobile",
      name: "mobileNumberCountryCode",
      formType: "mobile",
      label: "Mobile Number Country Code",
      placeholder: "Enter Mobile Number Country Code",
      // validation: { required: "Mobile Number Country Code is required" },
      hidden: true
    },
    {
      fieldName: "Mobile Number",
      fieldValue: "mobileNumber",
      className: "col-span-6",
      type: "mobile",
      name: "mobileNumber",
      formType: "mobile",
      label: "Mobile Number",
      placeholder: "Enter Mobile Number",
      validation: { 
        required: "Mobile Number is required",
        validate: (value) => {
          console.log("valueeeeeeeeeeee", value);
          
          // Check for undefined, null, empty string or falsy values
          if (!value || value === '' || value === undefined || value === null) {
            return "Mobile Number is required";
          }
          
          // Check for string representations of null/undefined
          if (
            typeof value === 'string' && (
              value.trim() === '' ||
              value.includes('null') ||
              value.includes('undefined') ||
              value === 'null' ||
              value === 'undefined'
            )
          ) {
            return "Mobile Number is required";
          }
          
          // Additional check for whitespace-only strings
          if (typeof value === 'string' && value.trim().length === 0) {
            return "Mobile Number is required";
          }
          
          // If all validations pass
          return true;
        }
      },
    },
    {
      fieldName: "Nationality",
      fieldValue: "nationality",
      className: "col-span-6",
      type: "text",
      name: "nationality",
      formType: "radioWithDropdown",
      label: "Nationality",
      placeholder: "Enter Nationality",
      validation: { required: "Nationality is required" },
      options: [{
        label: "Malaysian",
        value: "Malaysian"
      },{
        label: "Other",
        value: "Other"
      }],
      loadOptions: fetchOtherNationality
    },
    {
      fieldName: "Email",
      fieldValue: "emailAddress",
      className: "col-span-6",
      type: "text",
      name: "emailAddress",
      formType: "input",
      label: "Email",
      placeholder: "Enter Email",
      validation: { required: "Email is required" },
    },
    // {
    //   fieldName: "EPS ID",
    //   fieldValue: "epsId",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "epsId",
    //   formType: "input",
    //   label: "EPS ID",
    //   placeholder: "Enter EPS ID",
    //   // validation: { required: "EPS ID is required" },
    // },
    {
      fieldName: "Designation",
      fieldValue: "designation",
      className: "col-span-6",
      type: "text",
      name: "designation",
      formType: "input",
      label: "Designation",
      placeholder: "Enter Designation",
      // validation: { required: "Designation is required" },
    },
    {
      fieldName: "Home/Office Country Code",
      fieldValue: "homeNumberCountryCode",
      className: "col-span-6",
      type: "text",
      name: "homeNumberCountryCode",
      formType: "input",
      label: "Home/Office Country Code",
      placeholder: "Enter Home/Office Area Code",
      // validation: { required: "Home/Office Area Code is required" },
      hidden: true
    },
    {
      fieldName: "Home/Office Number",
      fieldValue: "homeNumber",
      className: "col-span-6",
      type: "mobile",
      name: "homeNumber",
      formType: "mobile",
      label: "Home/Office Number",
      placeholder: "Enter Home/Office Number",
      // validation: { required: "Home/Office Number is required" },
    },
    {
      fieldName: "Mailing Address",
      fieldValue: "mailingAddress",
      className: "col-span-6",
      type: "textarea",
      name: "mailingAddress",
      formType: "input",
      label: "Mailing Address",
      placeholder: "Enter Mailing Address",
      // validation: { required: "Mailing Address is required" },
    },
    {
      fieldName: "Postal Code",
      fieldValue: "postalCode",
      className: "col-span-6",
      type: "text",
      name: "postalCode",
      formType: "input",
      label: "Postal Code",
      placeholder: "Enter Postal Code",
      // validation: { required: "Postal Code is required" },
    },
    {
      fieldName: "Maritial Status",
      fieldValue: "maritialStatus",
      className: "col-span-6",
      type: "text",
      name: "maritialStatus",
      formType: "select",
      label: "Maritial Status",
      placeholder: "Enter Maritial Status",
      // validation: { required: "Maritial Status is required" },
      options: [{
        label: "Married",
        value: "Married"
      },{
        label: "Single",
        value: "Single"
      }]
    },
    {
      fieldName: "Income Range",
      fieldValue: "incomeRange",
      className: "col-span-6",
      type: "text",
      name: "incomeRange",
      formType: "select",
      label: "Income Range",
      placeholder: "Enter Income Range",
      // validation: { required: "Income Range is required" },
      options:  [
        {
            label: 'Below 1500',
            value: 'Below 1500'
        },
        {
            label: '1501 - 5000',
            value: '1501 - 5000'
        },
        {
          label: '5001 - 8000',
          value: '5001 - 8000'
        },
        {
          label: '8001 - 15000',
          value: '8001 - 15000'
        },
        {
          label: 'Not Applicable',
          value: 'Not Applicable'
        },
      ]
    },
    {
      fieldName: "Promo Material Via Email",
      fieldValue: "promotionsEmail",
      className: "col-span-12",
      type: "checkbox", //text
      name: "promotionsEmail",
      formType: "checkbox",  //multicheckbox
      label: "Promo Material Via Email",
      placeholder: "Enter Promo Material Via Email",
      // validation: { required: "Promo Material Via is required" },
      // options: [{
      //   label: "Email",
      //   value: "Email"
      // },
      // // {
      // //   label: "SMS",
      // //   value: "SMS"
      // // }
      // ]
    },
    {
      fieldName: "Is for Renewal?",
      fieldValue: "isForRenewal",
      className: "col-span-6",
      type: "checkbox",
      name: "isForRenewal",
      formType: "checkbox",
      label: "Is for Renewal?",
      placeholder: "Is for Renewal?",
      // validation: { required: "Postal Code is required" },
      hidden: true
    },
  ],
  enquiriesEmailTemplate:[
    {
      fieldName: "Email",
      fieldValue: "emailAddress",
      className: "col-span-6",
      type: "text",
      name: "emailAddress",
      formType: "input",
      label: "Email",
      editable: false,
      placeholder: "Enter Email",
      validation: { required: "Email is required" },
    },
    {
      fieldName: "Subject",
      fieldValue: "emailSubject",
      className: "col-span-6",
      type: "text",
      name: "emailSubject",
      formType: "input",
      label: "Subject",
      placeholder: "Enter Subject",
      editable: false,
      validation: { required: "Subject is required" },
    },
    {
      fieldName: "Message",
      fieldValue: "emailMessage",
      className: "col-span-6",
      type: "text",
      name: "emailMessage",
      formType: "richText",
      label: "Message",
      placeholder: "Enter Message",
      validation: { required: "Message is required" },
    },
  ]
};
